export default __webpack_public_path__ + "static/media/item_6@2x.cc050ebe.png";